import * as types from '../mutation-types'

export const mutations = {
  [types.SET_ALERTS] (state, { alerts }) {
    state.alerts = alerts
  },
}

const module = HTTP => ({
  state: {
    alerts: [],
  },
  mutations,
  actions: {
    async getAlerts ({ commit, rootState }) {
      try {
        const response = await HTTP.get('/alerts')
        const alerts = response.data

        commit(types.SET_ALERTS, { alerts: alerts })
      } catch (e) {
        console.log(e)
      }
    },
  },
})

export default {
  module,
}
